import React, { useState } from 'react';
import { SurveyProvider } from '../../../assets/js/SurveyContext';
import CreateSurveyStep0 from './CreateSurvey_0';
import CreateSurveyStep1 from './CreateSurvey_1';

const CreateStart = ({ onBack }) => {
  const [isSurveyCreated, setIsSurveyCreated] = useState(false);

  return (
    <SurveyProvider>
      {isSurveyCreated ? (
        <CreateSurveyStep1 onBack={() => setIsSurveyCreated(false)} />
      ) : (
        <CreateSurveyStep0 onSurveyCreate={() => setIsSurveyCreated(true)} onBack={onBack} />
      )}
    </SurveyProvider>
  );
};

export default CreateStart;
